import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TableModule } from 'primeng/table';
import { MatDialogModule } from '@angular/material/dialog';
import { MatRippleModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { AccordionModule } from 'primeng/accordion';
import { SelectButtonModule } from 'primeng/selectbutton';
import { CalendarModule } from 'primeng/calendar';
import { MiscModule } from 'projects/core/src/public-api';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { CustomerMiscModule } from '../customer/customer-misc.module';
import { CheckboxModule } from 'primeng/checkbox';
import { DropdownModule } from 'primeng/dropdown';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { InputSwitchModule } from 'primeng/inputswitch';
import { QbViewDialogComponent } from './view/qb-view-dialog/qb-view-dialog.component';
import { EstimateDialogComponent } from './view/estimate-dialog/estimate-dialog.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { EstInvInfoComponent } from './view/est-inv-info/est-inv-info.component';
import { InputTextModule } from 'primeng/inputtext';
import { SaleLinesComponent } from './view/est-inv-info/sale-lines/sale-lines.component';
import { TooltipModule } from 'primeng/tooltip';
import { CreateEstiinvDialogComponent } from './view/create-estiinv-dialog/create-estiinv-dialog.component';
import { InputMask, InputMaskModule } from 'primeng/inputmask';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { SendInvoiceDialogComponent } from './view/send-invoice-dialog/send-invoice-dialog.component';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { EmailPreviewComponent } from './view/email-preview/email-preview.component';
import { RadioButtonModule } from 'primeng/radiobutton';
import { InputNumberModule } from 'primeng/inputnumber';
import { MobileSaleLineComponent } from './view/est-inv-info/mobile-sale-line/mobile-sale-line.component';
import { MobileSaleEditorComponent } from './view/est-inv-info/mobile-sale-line/mobile-sale-editor/mobile-sale-editor.component';
import { SaleListChooserComponent } from './view/est-inv-info/mobile-sale-line/mobile-sale-editor/sale-list-chooser/sale-list-chooser.component';


@NgModule({
    declarations: [
        QbViewDialogComponent,
        EstimateDialogComponent,
        EstInvInfoComponent,
        SaleLinesComponent,
        CreateEstiinvDialogComponent,
        SendInvoiceDialogComponent,
        EmailPreviewComponent,
        MobileSaleLineComponent,
        MobileSaleEditorComponent,
        SaleListChooserComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        TableModule,
        MatDialogModule,
        MatRippleModule,
        MatIconModule,
        MatButtonModule,
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule,
        AccordionModule,
        SelectButtonModule,
        CalendarModule,
        MiscModule,
        OverlayPanelModule,
        CustomerMiscModule,
        CheckboxModule,
        DropdownModule,
        ConfirmDialogModule,
        InputSwitchModule,
        InputTextModule,
        InputNumberModule,
        TooltipModule,
        InputMaskModule,
        InputTextareaModule,
        RadioButtonModule,
        NgxExtendedPdfViewerModule,
        MatProgressSpinnerModule
    ],
    exports: [
        SaleLinesComponent
    ],
    entryComponents: [
        EstimateDialogComponent,
        SendInvoiceDialogComponent,
        MobileSaleEditorComponent,
        EmailPreviewComponent,
        SaleListChooserComponent
    ]
})
export class QBModule { }
